import React from 'react';

function Skeleton() {
    return (
        <>
            <style jsx='true'>{`
                *, *:before, *:after {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                    font-family: inherit;
                    border: 0;
                    font-size: 100%;
                }
                ol, ul {list-style: none;}
                .skeleton__title {
                    width: 38%;
                    height: 1rem;
                    background: hsla(0,0%,74.5%,.2);
                    border-radius: 4px;
                }

                .skeleton__paragraph {
                    margin-top: 1.4rem;
                }

                .skeleton__paragraph > li {
                    height: 1rem;
                    background: hsla(0,0%,74.5%,.2);
                    border-radius: 4px;
                }

                .skeleton__paragraph li:not(:first-child) {
                    margin-top: 1rem;
                }

                .skeleton__paragraph li:last-child {
                    width: 61%;
                }

                .skeleton__title, .skeleton__paragraph li {
                    background: -webkit-gradient(linear,left top,right top,color-stop(25%,hsla(0,0%,74.5%,.2)),color-stop(37%,hsla(0,0%,50.6%,.24)),color-stop(63%,hsla(0,0%,74.5%,.2)));
                    background: linear-gradient(90deg,hsla(0,0%,74.5%,.2) 25%,hsla(0,0%,50.6%,.24) 37%,hsla(0,0%,74.5%,.2) 63%);
                    background-size: 400% 100%;
                    -webkit-animation: skeleton--loading 1.4s ease infinite;
                    animation: skeleton--loading 1.4s ease infinite;
                }

                @-webkit-keyframes skeleton--loading {
                    0% {background-position: 100% 50%}
                    to {background-position: 0 50%}
                }

                @keyframes skeleton--loading {
                    0% {background-position: 100% 50%}
                    to {background-position: 0 50%}
                }
            `}</style>
            <div className='skeleton'>
                <div className='skeleton__title'>&nbsp;</div>
                <ul className='skeleton__paragraph'>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                </ul>
            </div>
        </>
    );
}

export default React.memo(Skeleton);